<template>

    <div class="body">
        <div class="body__container body__container-title">
            <h2 class="text-xlBold">{{ $t('cleaning_sort_by') }}</h2>
        </div>

        <div class="body__container">
            <p class="text-lSemibold">{{ $t('cleaning_sort_open_rate') }}</p>
            <div class="body__row mt__12" @click="clickSort(ENUM.NEWSLETTERS.SORT.MOST_OPEN)">
                <img :src="isSortMostOpen ? checkTrue : checkFalse"
                     class="body__row__img">
                <p class="text-lMedium" :class="{'color__charcoal': isSortMostOpen, 'color__moon': !isSortMostOpen}">{{ $t('cleaning_sort_more_open') }}</p>
            </div>
            <div class="body__row mt__10" @click="clickSort(ENUM.NEWSLETTERS.SORT.LEAST_OPEN)">
                <img :src="isSortLeastOpen ? checkTrue : checkFalse"
                     class="body__row__img">
                <p class="text-lMedium" :class="{'color__charcoal': isSortLeastOpen, 'color__moon': !isSortLeastOpen}">{{ $t('cleaning_sort_less_open') }}</p>
            </div>
        </div>

        <div class="body__container">
            <p class="text-lSemibold">{{ $t('cleaning_nb_mail_received') }}</p>
            <div class="body__row mt__12" @click="clickSort(ENUM.NEWSLETTERS.SORT.ASCENDING)">
                <img :src="isSortAscending ? checkTrue : checkFalse"
                     class="body__row__img">
                <p class="text-lMedium" :class="{'color__charcoal': isSortAscending, 'color__moon': !isSortAscending}">
                    {{ $t('cleaning_sort_ascending_order') }}
                </p>
            </div>
            <div class="body__row mt__10" @click="clickSort(ENUM.NEWSLETTERS.SORT.DESCENDING)">
                <img :src="isSortDescending ? checkTrue : checkFalse"
                     class="body__row__img">
                <p class="text-lMedium" :class="{'color__charcoal': isSortDescending, 'color__moon': !isSortDescending}">{{ $t('cleaning_sort_descending_order') }}</p>
            </div>
        </div>

        <div class="body__container">
            <p class="text-lSemibold">{{ $t('sort_date_title') }}</p>
            <div class="body__row mt__12" @click="clickSort(ENUM.NEWSLETTERS.SORT.UP_TO_DATE)">
                <img :src="isSortUpToDate ? checkTrue : checkFalse"
                     class="body__row__img">
                <p class="text-lMedium" :class="{'color__charcoal': isSortUpToDate, 'color__moon': !isSortUpToDate}">
                    {{ $t('sort_date_more_recent') }}
                </p>
            </div>
            <div class="body__row mt__10" @click="clickSort(ENUM.NEWSLETTERS.SORT.OLDEST)">
                <img :src="isSortOldest ? checkTrue : checkFalse"
                     class="body__row__img">
                <p class="text-lMedium" :class="{'color__charcoal': isSortOldest, 'color__moon': !isSortOldest}">{{ $t('sort_date_less_recent') }}</p>
            </div>
        </div>

        <div class="body__container">
            <button class="body__btn text-lSemibold color__white" @click="valid">{{ $t('cleaning_validate_sort') }}
            </button>
        </div>

    </div>

</template>

<script>
import Vuex from 'vuex'

import ENUM from '@/assets/ENUM'

import Tag from '@/modules/tag'

export default {

    name: 'sort-body',

    computed: {

        ...Vuex.mapGetters(['newslettersSort']),

        ENUM() {
            return ENUM
        },

        isSortMostOpen() {
            return this.selectedSort === ENUM.NEWSLETTERS.SORT.MOST_OPEN
        },

        isSortLeastOpen() {
            return this.selectedSort === ENUM.NEWSLETTERS.SORT.LEAST_OPEN
        },

        isSortAscending() {
            return this.selectedSort === ENUM.NEWSLETTERS.SORT.ASCENDING
        },

        isSortDescending() {
            return this.selectedSort === ENUM.NEWSLETTERS.SORT.DESCENDING
        },

        isSortUpToDate() {
            return this.selectedSort === ENUM.NEWSLETTERS.SORT.UP_TO_DATE
        },

        isSortOldest() {
            return this.selectedSort === ENUM.NEWSLETTERS.SORT.OLDEST
        }
    },

    data() {
        return {
            selectedSort: '',
            checkTrue: '/img/newsletters-v2/check-list-on.svg',
            checkFalse: '/img/newsletters-v2/check-list-off.svg',
        }
    },

    mounted() {
        this.updateSelectedSort(this.newslettersSort)
    },

    methods: {

        ...Vuex.mapActions(['updateNewslettersSort']),

        valid() {
            Tag.clickGA(this, 'validate')
            this.updateNewslettersSort(this.selectedSort)
            this.$emit('close')
        },

        clickSort(sortBy) {

            switch (sortBy) {
                case ENUM.NEWSLETTERS.SORT.MOST_OPEN:
                    Tag.clickGA(this, 'order_open_down')
                    break
                case ENUM.NEWSLETTERS.SORT.LEAST_OPEN:
                    Tag.clickGA(this, 'order_open_up')
                    break
                case ENUM.NEWSLETTERS.SORT.ASCENDING:
                    Tag.clickGA(this, 'order_email_up')
                    break
                case ENUM.NEWSLETTERS.SORT.DESCENDING:
                    Tag.clickGA(this, 'order_email_down')
                    break
                case ENUM.NEWSLETTERS.SORT.UP_TO_DATE:
                    Tag.clickGA(this, 'sort_most_recent')
                    break
                case ENUM.NEWSLETTERS.SORT.OLDEST:
                    Tag.clickGA(this, 'sort_less_recent')
                    break
            }

            this.updateSelectedSort(sortBy)
        },

        updateSelectedSort(sort) {
            this.selectedSort = sort
        }
    }
}
</script>

<style lang="scss" scoped>

.body {
    width: 100%;

    &__container {
        width: 100%;
        padding: 16px;
        display: flex;
        flex-direction: column;
        text-align: start;
        border-bottom: 1px solid $divider;
    }
    &__container-title {
        padding-top: 8px;
        @media screen and (min-width: $above-tablet-length) {
            padding-top: 16px;
        }
    }

    &__row {
        display: flex;
        flex-direction: row;
        align-items: center;
        cursor: pointer;

        &__img {
            width: 20px;
            object-fit: contain;
            margin-right: 8px;

            &:lang(ar-sa) {
                margin-right: 0;
                margin-left: 8px;
            }
        }
    }

    &__btn {
        padding: 17px;
        background-color: $midnight;
        border-radius: 72px;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
    }
}
</style>
